import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { List } from 'immutable';
var marksMap = {
  italic: function italic() {
    return {
      italic: true
    };
  },
  bold: function bold() {
    return {
      bold: true
    };
  },
  strikethrough: function strikethrough() {
    return {
      strikethrough: true
    };
  },
  subscript: function subscript() {
    return {
      subscript: true
    };
  },
  superscript: function superscript() {
    return {
      superscript: true
    };
  },
  underline: function underline() {
    return {
      underline: true
    };
  },
  highlight: function highlight(_ref) {
    var data = _ref.data;
    return {
      highlight: data.toJS()
    };
  },
  code: function code() {
    return {
      code: true
    };
  },
  comment: function comment(_ref2) {
    var type = _ref2.type,
        data = _ref2.data;
    return _defineProperty({}, "".concat(type, ":").concat(data.get('id')), true);
  },
  "default": function _default() {}
};

var reduceMarksType = function reduceMarksType(memo, mark) {
  return _objectSpread({}, memo, {}, (marksMap[mark.type] || mark.data && !mark.data.isEmpty() && marksMap.entity || marksMap["default"])(mark));
};

export default (function (_ref4) {
  var _ref4$marks = _ref4.marks,
      marks = _ref4$marks === void 0 ? new List() : _ref4$marks;
  return !marks.isEmpty() ? marks.reduce(reduceMarksType, {}) : undefined;
});